import { defineStore } from 'pinia';
import { User } from '@/models/User';
import { Preferences } from '@capacitor/preferences';

export const useUserStore = defineStore('user', {

  state: () : User => ({
    isMobile:false, 
    view:'Insecal Inspección',
    username: '',
    password: '',
    userData: {id:0, email:'',first_access:false,name:''},
    validSession: false,
    rememberMe:false,
  }),
  
  actions: {
    async set(userdata: object) {
      // Guardar el usuario en Preferences
      await Preferences.set({
        key: 'user',
        value: JSON.stringify(userdata),
      });
    },   
    setView(view: string){
      this.view = view;
    },
    async setRememberMe(rememberme:boolean){
      if(rememberme){
        await Preferences.set({
          key:'rememberUser',
          value: JSON.stringify({username:this.username,password:this.password, rememberme:true})
        });
      }else{
        await Preferences.remove({ key:'rememberUser'});
      }
    },
    async clear(){
      this.isMobile=false;
      this.view = 'Insecal Inspección';
      this.username =  '';
      this.password =  '';
      this.userData = { id:0, email:'',first_access:false,name:'' };
      this.validSession = false;
      this.rememberMe = false;
      // Limpiar todos los datos de Preferences
      await Preferences.remove({ key: 'user'});
      await Preferences.remove({ key: 'client_token'});
      await Preferences.remove({ key: 'token_expiration'});
      await Preferences.remove({ key: 'explotacion'});
    },
    async saveToken(token: string, expiresInSeconds: number) {
      const expirationTimestamp = Date.now() + expiresInSeconds * 1000; // Convertir segundos a milisegundos
      await Preferences.set({ key: 'client_token', value: token });
      await Preferences.set({ key: 'token_expiration', value: expirationTimestamp.toString() });
    }
  },
  getters:{
    async getUserData(state) {
      // Obtener el usuario desde Preferences
      const { value } = await Preferences.get({ key: 'user' });
      state.userData = value ? JSON.parse(value) : null;
      return state.userData;
    },
    async getToken(): Promise<string | null> {
      const { value: token } = await Preferences.get({ key: 'client_token' });
      const { value: expiration } = await Preferences.get({ key: 'token_expiration' });
    
      if (token && expiration) {
        const now = Date.now();
        const expirationTimestamp = parseInt(expiration, 10); // Convertir a número
    
        if (now < expirationTimestamp) {
          return token; // El token es válido
        } else {
          await Preferences.remove({ key: 'client_token'});
          await Preferences.remove({ key: 'token_expiration'});
          return null;
        }
      }
    
      return null; // No hay token o expiró
    },
    async getStorageUser(){
      const { value } = await Preferences.get({ key: 'rememberUser' });
      return value? JSON.parse(value) : null;
    }
  }
})